import React, { useState, useContext, useEffect, useCallback } from 'react'
import { ClearTheChartsContext } from '../ClearTheChartsContext'

const Item = ({ item, setGameMode, onSelect }) => {
  return (
    <div
      onClick={() => {
        setGameMode('chartStats')
        onSelect()
      }}
    >
      <ChartName chart={item.chart} />
    </div>
  )
}

const ChartName = ({ chart, setGameMode }) => {
  const { stackDepth, position, vsAction, oppPosition, type, chartType } =
    chart || {}

  const getTypeLabel = useCallback(() => {
    const typeValue = type || chartType

    if (!typeValue) return
    if (typeValue.toLowerCase().includes('cash')) return 'CASH'
    return 'TOURNEY'
  }, [type, chartType])

  return (
    <div
      className="ClearTheCharts__button"
      style={{
        width: '100%',
        minWidth: '100%',
        marginTop: '10px',
        cursor: 'pointer',
        border: 'none',
      }}
    >
      <div
        className="ClearTheCharts__button-label"
        style={{
          fontSize: '16px',
          fontWeight: '400',
          textAlign: 'center',
          textTransform: 'uppercase',
          fontFamily: ' Roboto, sans-serif',
        }}
      >
        {getTypeLabel()} | {stackDepth}BBs | {position}{' '}
        {oppPosition == null ? '' : `vs ${oppPosition}`}
        {vsAction == 'null' ? '' : vsAction?.replace('VS', '')}{' '}
      </div>
    </div>
  )
}

const MyCharts = ({ setGameMode }) => {
  const { state, dispatch } = useContext(ClearTheChartsContext)

  const [chartsToShow, setChartsToShow] = useState([])
  const { userStats, preflopCharts } = state

  useEffect(() => {
    const chartsToShowData = Object.values(userStats).reduce(
      (acc, curr, index) => {
        const { wins, chartId } = curr

        if (!wins) return acc

        return [
          ...acc,
          { ...curr, order: index + 1, chart: preflopCharts[chartId] },
        ]
      },
      [],
    )
    setChartsToShow(chartsToShowData)
  }, [])

  return (
    <div
      style={{
        overflowY: 'scroll',
        maxHeight: '60vh',
      }}
    >
      <p
        style={{
          fontFamily: 'Roboto, sans-serif',
          fontSize: '18px',
          marginTop: '10px',
        }}
        className="ClearTheCharts__label"
      >
        My Charts
      </p>
      {!!chartsToShow?.length ? (
        chartsToShow.map((item) => {
          return (
            <Item
              onSelect={() =>
                dispatch({
                  type: 'set-active-shart-stats',
                  payload: { chart: item },
                })
              }
              key={item.chartId}
              setGameMode={setGameMode}
              item={item}
            />
          )
        })
      ) : (
        <div style={{ fontSize: '14px' }} className="ClearTheCharts__label">
          You do not have completed charts at the moment
        </div>
      )}
    </div>
  )
}

export default MyCharts
